import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDynamicDashboardModule } from '@mare-common/ngx-dynamic-dashboard';
import { IndicatorComponent } from 'src/app/shared/indicator/indicator.component';
import { CurrencyFormatterPipe } from 'src/app/shared/pipes/currency-formatter.pipe';
import { ChartBuilderService, ChartTypes } from 'src/app/services/chart-builder.service';
import { ChartConfigService } from 'src/app/services/chart-config.service';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { PlotlyViaWindowModule } from 'angular-plotly.js';
import { Subject} from 'rxjs';
import { HelpInlineComponent } from 'src/app/shared/help-inline/help-inline.component';
import { LandingService } from 'src/app/services/landing.service';
import { OverviewDetailsComponent } from './components/overview-details/overview-details.component';
import { LeafletMapComponent } from 'src/app/shared/leaflet-map/leaflet-map.component';

@Component({
  selector: 'company-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['../../company-identity.component.scss', './overview.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    SharedModule,
    TranslateModule,
    NgxDynamicDashboardModule,
    IndicatorComponent,
    MatIconModule,
    MatCardModule,
    PlotlyViaWindowModule,
    HelpInlineComponent,
    OverviewDetailsComponent,
    LeafletMapComponent
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewComponent implements OnInit {
  @Input() company: any;
  @Input() ateco!: string;
  @Input() piva!: string | number;
  @Input() chartConfig!: any;
  @ViewChild('plotQuotaDiMercato') plotQuotaDiMercato!: PlotlyViaWindowModule;
  graphicEmployees!: {
    data: any,
    layout: any
  };

  employees$ = signal('0');
  certifications$ = signal('0');

  company$ = signal(null);

  companyProfits$ = computed(() => {
    if (this.company?.financialStatements) {
      let latestFinancialStatement = this.company.localFinancialStatements
      .filter((fs:any) => fs.type === 'LocalFinancialsCSIT')
      .sort((a:any, b:any) => new Date(b.yearEndDate).getTime() - new Date(a.yearEndDate).getTime())[0].profitAndLoss
      return latestFinancialStatement;
    } return null
  });

  revenue$ = computed(() => {
    if (this.companyProfits$()?.revenue) {
      let formattedValue = this.currencyPipe.transform(this.companyProfits$().revenue);
      return formattedValue;
    } return '0'
  });

  profits$ = computed(() => {
    if (this.companyProfits$()?.retainedProfit) {
      let formattedProfists = this.currencyPipe.transform(this.companyProfits$().retainedProfit);
      return formattedProfists;
    } return '0'
  });
  

  currencyPipe = new CurrencyFormatterPipe();
  
  // charts objects
  quotaDiMercatoChart: any;
  fatturatoDiSettore: any;
  fatturatoAzienda: any;
  
  ebitdaDiSettore: any;
  ebitdaAzienda: any;
  ebitdaChart: any;
  ebitdaChartMode:'INDICATOR'|'BAR'|'PIE' = 'INDICATOR';
  quotaDiMercato$ = signal({});
  quotaDiMercato: any;
  indiceDiInnovazione: any;
  unsubscribe: Subject<any> = new Subject();
  profitsValueDiff: any;

  ebitdaValueDiffPerc$ = signal<string>('');
  ebitdaValueDiff$ = signal<number>(0);

  constructor(
    private chartBuilderService: ChartBuilderService,
    private chartConfigService: ChartConfigService,
    private landingService: LandingService) {
    // this.company$.set(this.company);
    }
  ngOnInit(): void {
    this.company$.set(this.company);
    let ateco = this.company?.companySummary?.mainActivity?.code;
    if (ateco) {
      // this.initChartQuotaDiMercato(ateco);
      // this.initChartInnovationIndex(ateco);
     
      // this.initchartEbitda(ateco);

      this.initChartsOverview(ateco);
    }
  }

  // initChartsOverview_orig(ateco: string) {
  //   let data = this.chartConfigService.retrieveChartOverview(ateco);
  //   this.chartConfigService.makeChartOverviewApiCall(data).then((response: any) => {
  //     let quotachart = response?.payload?.find((el: any) => el?.graphicInfo.id === 'UUID-DSHB-08826186-267b-4d15-8d00-0e3fe92cedf5');
  //     this.initChartQuotaDiMercato(quotachart?.result[0]?.value)
  //     let ebitdaChart = response?.payload?.find((el: any) => el?.graphicInfo.id === 'UUID-DSHB-d9646f1f-37e6-45fc-87ec-150ed5ed17d6');
  //     this.initchartEbitda(ebitdaChart?.result[0])
  //     let innovationChart = response?.payload?.find((el: any) => el?.graphicInfo.id === 'UUID-DSHB-b5cc37fe-9d7f-4407-8be2-28393745674a');
  //       this.initChartInnovationIndex(innovationChart?.result[0]?.value)
  //   })
  // }
  initChartsOverview(ateco: string) {
    this.landingService.getDashboard().then((response: any) => {
      // recuperiamo il fatturato di settore
      let fatturatoDiSettore = response.istat.fatturato_settore;
      this.initChartQuotaDiMercato(fatturatoDiSettore);
      let ebitDaDiSettore = response.istat.dettagli_finanziari_settore.sort((a: any, b: any) => b.anno - a.anno)[0].ebitda;
     
      this.initchartEbitda(ebitDaDiSettore);
      console.log(response); //response

      let innovation_index = response.istat.innovation_index
      this.initChartInnovationIndex(innovation_index)
    })
    // let data = this.chartConfigService.retrieveChartOverview(ateco);
    // this.chartConfigService.makeChartOverviewApiCall(data).then((response: any) => {
    //   // let quotachart = response?.payload?.find((el: any) => el?.graphicInfo.id === 'UUID-DSHB-08826186-267b-4d15-8d00-0e3fe92cedf5');
    //   // this.initChartQuotaDiMercato(quotachart?.result[0]?.value)
    //   // let ebitdaChart = response?.payload?.find((el: any) => el?.graphicInfo.id === 'UUID-DSHB-d9646f1f-37e6-45fc-87ec-150ed5ed17d6');
    //   // this.initchartEbitda(ebitdaChart?.result[0])
    //   let innovationChart = response?.payload?.find((el: any) => el?.graphicInfo.id === 'UUID-DSHB-b5cc37fe-9d7f-4407-8be2-28393745674a');
    //     this.initChartInnovationIndex(innovationChart?.result[0]?.value)
    // //   })
    // })

  }

  // ngAfterViewInit() {
  //   console.log(this.plotQuotaDiMercato);
  // }
  ngOnDestroy() {
    this.unsubscribe.unsubscribe();
  }

  initChartQuotaDiMercato(valuequota: any) {
    // let ateco = this.company?.companySummary?.mainActivity?.code;
    if (!valuequota){
      return;
    }
    this.fatturatoDiSettore = valuequota;
    this.fatturatoAzienda =this.companyProfits$().totalValueOfProduction;
    this.quotaDiMercato = (this.fatturatoAzienda / this.fatturatoDiSettore) * 100;
    if(this.quotaDiMercato < 1) {
      this.quotaDiMercato = this.quotaDiMercato.toFixed(this.arrotondaMinimoDecimale(this.quotaDiMercato)) + '%';
    } else {
    this.quotaDiMercato = this.quotaDiMercato.toFixed(2) + '%';
    }
      //   let quotaDiMercatoChart = [
      //     {
      //       id: "myquota",
      //       valuefor: "Quota di mercato",
      //       value: this.quotaDiMercato
      //     },
      //     // {
      //     //   id: "marketquota",
      //     //   valuefor: "Valore fatturato di mercato",
      //     //   value: 100 - this.quotaDiMercato
      //     // }
      //   ]
      //  let textValue = this.currencyPipe.transform(this.fatturatoAzienda);
      //   this.quotaDiMercatoChart = this.buildQuoteChart('quotechart',quotaDiMercatoChart,'INDICATOR',textValue);
     
  }

  initChartInnovationIndex(valuequota:any) {
    if (!valuequota)
      return;
    this.indiceDiInnovazione = valuequota + '%';
  }

  initchartEbitda(resultSector: any,) {
    // this.ebitdaDiSettore = resultSector.molMedio;
    // this.ebitdaDiSettore = resultSector.fatturatoMedio - resultSector.salariStipendiMedio - resultSector.acquistoBeniServiziMedio; 
    this.ebitdaDiSettore = resultSector
    this.ebitdaAzienda = this.companyProfits$().ebitda;
    let ebitdaValueDiffPerc = ((this.ebitdaAzienda / this.ebitdaDiSettore) * 100).toFixed(2) + '%';
    this.ebitdaValueDiffPerc$.set(ebitdaValueDiffPerc);
    let ebitdaValueDiff = this.ebitdaAzienda - this.ebitdaDiSettore;
    this.ebitdaValueDiff$.set(ebitdaValueDiff);

    let ebitdaabs = Math.abs(this.ebitdaAzienda);
    if(this.ebitdaChartMode != 'INDICATOR') {
          let ebitdavalues = [{
            id: "ebitda",
            valuefor: "Azienda",
            value: this.ebitdaAzienda
          }, {
            id: "ebitdaSettore",
            valuefor: "Media di Settore",
            value:  this.ebitdaDiSettore
            }];
            let textValue = this.currencyPipe.transform(this.ebitdaAzienda);
          this.ebitdaChart = this.buildQuoteChart('ebitdachart', ebitdavalues, this.ebitdaChartMode, textValue);
        }

    //   })// end sub
    // })
  }

  buildQuoteChart(id: string, values: Array<any>, type: ChartTypes, textValue?: string) {

    let objValues: { ros: { id: string; valuefor: string; value: number; }[] } = {
			ros: []
		}
		for (const val of values) {
			objValues.ros.push({ id: val.id, valuefor: val.valuefor, value: val.value })
    }
    
    let _graphicData:any = this.chartBuilderService.buildChart(id, type , '', '&nbsp;', 'ros', 'valuefor', 'value', objValues, '', '56', '88', '%');
    if (_graphicData.graphic.data?.length > 0) {
      if (type === 'PIE') {
        
        _graphicData.graphic.data[0].hole = 0.6;
        _graphicData.graphic.data[0].hoverinfo = 'label+value';
        _graphicData.graphic.data[0].hovertemplate = '%{label}<br>%{value:.2f} €';
        _graphicData.graphic.layout.height = 200;

        _graphicData.graphic.layout.annotations = [
          {
            font: {
              size: 20,
              family: '"Pt Sans Narrow","Open Sans", verdana, arial, sans-serif'
            },
            showarrow: false,
            text:textValue ?? '',
            x: 0.5,
            y: 0.5
          },
        ]
      }
      else {
        // _graphicData.graphic.data[0].textposition = 'inside';
        _graphicData.graphic.data[0].insidetextfont = { size: 16 }
        // _graphicData.graphic.data[0].hoverinfo = 'none';
        _graphicData.graphic.data[0].height = [0.8, 0.8];
        _graphicData.graphic.data[0].orientation = 'h';
        _graphicData.graphic.data[0].texttemplate = '%{label}';

        // invertiamo i valori se il grafico è orizzontale
        if (_graphicData.graphic.data[0].orientation == 'h') {
          let x = _graphicData.graphic.data[0].x;
          let y = _graphicData.graphic.data[0].y;

          _graphicData.graphic.data[0].x = y;
          _graphicData.graphic.data[0].y = x;
        }
       
      }
      _graphicData.graphic.data[0].marker.color = ['#061D52','#0BAAB7'];
      // _graphicData.graphic.data[0].name = 'name';
      // _graphicData.graphic.data[0].text = 'text';
      
    }
    _graphicData.graphic.layout.margin = { t: 0, b: 0, l: 0, r: 0 };
    _graphicData.graphic.layout.showlegend = false;
		_graphicData.graphic.layout.paper_bgcolor = 'rgba(0,0,0,0)';
    _graphicData.graphic.layout.plot_bgcolor = 'rgba(0,0,0,0)';
    _graphicData.graphic.layout.yaxis = { showticklabels: false, fixedrange: true }; 
    _graphicData.graphic.layout.font = {
      color: '#fdc400', size: 14,
      family: '"Pt Sans Narrow","Open Sans", verdana, arial, sans-serif'
    };
    // _graphicData.graphic.layout.autosize = true;
    //  _graphicData.graphic.layout.automargin = true;
  
   
    
    let config = {
			displayModeBar: false,
			modeBarButtonsToRemove: ['toImage'],
      displaylogo: false,
      responsive: true
		}
    _graphicData.graphic.config = config;
  
    return _graphicData;
  
  }

  buildBarChart(values: Array<any>, lossProfists: number ) {
		let trendColors = lossProfists  > 0 ? ['#ffe23f', '#0025ff']:['#0025ff', '#ffe23f'];
		
		
		let objValues: { ros: { id: string; valuefor: string; value: number; }[] } = {
			ros: []
		}
		for (const val of values) {
			objValues.ros.push({ id: val.id, valuefor: val.valuefor, value: val.value })
		}

		let _graphicDataOverview:any = this.chartBuilderService.buildChart('ros', 'PIE', '', '&nbsp;', 'ros', 'valuefor', 'value', objValues, '', '200', '150', '%');
		if (_graphicDataOverview.graphic.data?.length > 0) {
			// _graphicDataOverview.graphic.data[0].hole = 0.6;
			_graphicDataOverview.graphic.data[0].marker.color = trendColors;
			_graphicDataOverview.graphic.data[0].textposition = 'inside';
			// format texttemplate to convert value into millions, miles or billions
      _graphicDataOverview.graphic.data[0].texttemplate = '%{value:.2f}%';//[this.profittabilitaAzienda.toFixed(2), this.profittabilitaMercato.toFixed(2)]; //'%{value:.2f}€';
			_graphicDataOverview.graphic.data[0].hoverinfo = 'none';//
			// _graphicDataOverview.graphic.data[0].width = [0.7, 0.7]
			// _graphicDataOverview.graphic.data[0].orientation= 'h'
		}
    _graphicDataOverview.graphic.layout.margin = { t:0, b: 0, l: 0, r: 0 };
    // _graphicDataOverview.graphic.layout.automargin = true;
	  _graphicDataOverview.graphic.layout.showlegend = false;
		_graphicDataOverview.graphic.layout.paper_bgcolor = 'rgba(0,0,0,0)';
		_graphicDataOverview.graphic.layout.plot_bgcolor = 'rgba(0,0,0,0)';
    _graphicDataOverview.graphic.layout.font = {
      color: '#ffffff', size: 20,
      family: '"Pt Sans Narrow","Open Sans", verdana, arial, sans-serif'
    };

		let config = {
			displayModeBar: false,
			modeBarButtonsToRemove: ['toImage'],
			displaylogo: false,
		}
    _graphicDataOverview.graphic.config = config;

    return _graphicDataOverview;

  }

  arrotondaMinimoDecimale(numero:number) {
    // Converti il numero in stringa
    const numStr = numero.toString();
    
    // Ciclo per iterare sui caratteri della stringa
    for (let i = 0; i < numStr.length; i++) {
      // Se il carattere è una cifra non 0, restituisce l'indice
      if (/[1-9]/.test(numStr[i])) {
        // tolgo il primo 0 e se stesso
        return i;
      }
    }

    // Se non ci sono cifre non 0, restituisce -1
    return 0;
  }

}